import { getPersonalDetailsByRoleAndEmail } from "../../../../context/HelperFunctions/getPreferredGreetingName";

// Preview switch: false restores birthday-only behaviour for the signed-in user.
export const FORCE_BIRTHDAY_GREETING = false;

export async function loadBirthday(user, role) {
  if (!user?.email || !role) return null;
  const details = await getPersonalDetailsByRoleAndEmail({ role, email: user.email });
  return details?.dob || details?.dateOfBirth || null;
}

export function isBirthday(dob, timestamp) {
  // Legacy timestamps represent instants; interpret their calendar date in UK
  // time rather than the browser's timezone. Date-only strings stay unchanged.
  if (dob && typeof dob === "object") {
    try {
      const date = typeof dob.toDate === "function" ? dob.toDate()
        : dob instanceof Date ? dob
          : typeof dob.seconds === "number" && Number.isFinite(dob.seconds)
            ? new Date(dob.seconds * 1000) : null;
      if (!(date instanceof Date) || !Number.isFinite(+date)) return false;
      const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/London", year: "numeric", month: "2-digit", day: "2-digit",
      }).formatToParts(date);
      const part = type => parts.find(item => item.type === type)?.value;
      dob = `${part("year")}-${part("month")}-${part("day")}`;
    } catch {
      return false;
    }
  }
  if (typeof dob !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(dob)) return false;
  const parsed = new Date(`${dob}T00:00:00Z`);
  if (!Number.isFinite(+parsed) || parsed.toISOString().slice(0, 10) !== dob) return false;
  if (!Number.isFinite(+new Date(timestamp))) return false;
  const today = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date(timestamp));
  return dob.slice(5, 7) === today.find(part => part.type === "month")?.value &&
    dob.slice(8, 10) === today.find(part => part.type === "day")?.value;
}
